import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from "material-ui/styles";
import KeymanAttributeComponent from '../../OrderDashboardPages/parts/KeymanAttribute';

const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
})

class KeymanAttribute extends React.Component {
  render() {
    const { classes, item } = this.props;
    return (
      <div className={classes.root}>
        <KeymanAttributeComponent item={item} style={{ width: "293px", marginRight: "87px" }} />
      </div>
    );
  }
}

KeymanAttribute.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
};

export default withStyles(styles)(KeymanAttribute);



// WEBPACK FOOTER //
// ./src/components/OrderDetail/parts/KeymanAttribute.jsx